export const registrationClasses = {

    "Registered Nurse":[

        "General",

        "Extended",

        "Graduate",

        "Temporary"

    ],

    Pharmacist:[

        "General",

        "Intern",

        "Student"

    ]

};